import { connect } from 'react-redux'
import { getWaiChuBack,getWaiChuBackChecklist,deleteWaiChuBack} from './actions'
import Setting from './main'


const mapDispatchToProps = {
    getWaiChuBack,
    getWaiChuBackChecklist,
    deleteWaiChuBack
}
const mapStateToProps = (state) => {
  return {
    ...state.WaiChuBackList
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
